import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

// Import SCSS - MODULAR: Button își importă propriul SCSS
import './Button.scss';

const Button = ({ 
  children, 
  type = 'primary', 
  as = 'button', 
  to, 
  onClick, 
  inverted = false, 
  ...props 
}) => {
  // Configurăm clasele CSS în funcție de props
  const baseClass = 'btn';
  const typeClass = `btn-${type}`;
  const invertedClass = inverted ? 'inverted' : '';
  const className = `${baseClass} ${typeClass} ${invertedClass}`;
  
  // Dacă este un link, redăm un Link din react-router-dom
  if (as === 'link' && to) {
    return (
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <Link 
          to={to} 
          className={`${className} btn-link`}
          onClick={onClick}
          {...props}
        >
          {children}
        </Link>
      </motion.div>
    );
  } 
  
  // Altfel, redăm un buton normal
  return (
    <motion.button 
      className={className}
      onClick={onClick}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      {...props}
    >
      {children}
    </motion.button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['primary', 'secondary']),
  as: PropTypes.oneOf(['button', 'link']),
  to: PropTypes.string, // Necesar doar pentru link-uri
  onClick: PropTypes.func,
  inverted: PropTypes.bool
};

export default Button;
